import React from "react";
import { Tabs, Card, Row, Col, Spin } from "antd";
import { FilePdfOutlined, TeamOutlined, UserOutlined, FileAddOutlined, FireOutlined } from "@ant-design/icons";
// UPDATED: Removed context import
// import { useSelectedYear } from "../../Context/SelectYearContext";
import { useSelector } from "react-redux";
import { getUserData } from "../login/LoginSlice";
// UPDATED: Added imports for Redux financial year state
import { selectSelectedYearId, selectFinancialYears } from "../../Redux/financialYearSlice";

const Document = ({
  loading,
  activeTab,
  setActiveTab,
  DocumentDetails,
  selectedPolicyNumber,
  setSelectedPolicyNumber,
  selectedData, // This prop isn't used here but keeping it in case
}) => {
  // UPDATED: Get financial year details from Redux instead of Context
  const selectedYearId = useSelector(selectSelectedYearId);
  const yearList = useSelector(selectFinancialYears);
  const selectedYear = yearList.find(year => year.id === selectedYearId)?.financial_year || "";
  
  const policyTypes = Object.keys(DocumentDetails || {});
  const user = useSelector(getUserData);

  const handleTabChange = (key) => {
    setActiveTab(key);
    const firstPolicy = DocumentDetails[key]?.[0];
    const hasValidPolicyNumber = firstPolicy?.policy_number && 
      (typeof firstPolicy.policy_number === 'string' ? firstPolicy.policy_number.trim() !== "" : true);
    const policyKey = hasValidPolicyNumber ? firstPolicy.policy_number : (firstPolicy?.policy_id || `policy-0`);
    setSelectedPolicyNumber(policyKey);
  };

  const handlePolicyNumberClick = (policyNumber) => {
    setSelectedPolicyNumber(policyNumber);
  };

  const getTabIcon = (type) => {
    switch (type) {
      case "GMC":
        return <TeamOutlined style={{ marginRight: 8 }} />;
      case "GTL":
        return <UserOutlined style={{ marginRight: 8 }} />;
      case "GPA":
        return <TeamOutlined style={{ marginRight: 8 }} />;
      case "Parent policy":
        return <TeamOutlined style={{ marginRight: 8 }} />;
      case "Topup":
        return <FileAddOutlined style={{ marginRight: 8 }} />;
      case "Fire":
        return <FireOutlined style={{ marginRight: 8 }} />;
      default:
        return null;
    }
  };

  const renderDocuments = (documents) => {
    if (documents && documents.length > 0 && documents[0].document && documents[0].document.length > 0) {
      return (
        <Card>
          <Row gutter={[16, 16]} style={{ marginTop: "20px" }}>
            {documents[0].document.map((docUrl, index) => (
              <Col span={4} key={index}>
                <div className="document-item" style={{ textAlign: "center" }}>
                  <a
                    href={docUrl}  
                    target="_blank"            
                    rel="noopener noreferrer"
                  >
                    <FilePdfOutlined
                      style={{ fontSize: "100px", color: "#FF6347" }}
                    />
                  </a>
                  <p style={{ padding: "10px" }}>PDF Copy</p>
                </div>
              </Col>
            ))}
          </Row>
        </Card>
      );
    } else {
      return (
        <div className="escalation-message">
          No documents found for this policy.
        </div>
      );
    }
  };

  const tabItems = policyTypes.map((type) => ({
    key: type,
    label: (
      <span style={{ display: "flex", alignItems: "center", gap: "5px" }}>
        {type}
        {getTabIcon(type)}
      </span>
    ),
    children: (
      <>
        <Tabs
          activeKey={selectedPolicyNumber}
          onChange={handlePolicyNumberClick}
          items={DocumentDetails[type]?.map((policy, index) => {
            const hasValidPolicyNumber = policy.policy_number && 
              (typeof policy.policy_number === 'string' ? policy.policy_number.trim() !== "" : true);
            const policyKey = hasValidPolicyNumber ? policy.policy_number : (policy.policy_id || `policy-${index}`);
            return {
              key: policyKey,
              label: hasValidPolicyNumber ? (
                policy.policy_number
              ) : (
                <span
                  style={{
                    color: "#000000E0",
                    background: "#FFFF00",
                    padding: "2px 8px",
                    fontSize: "12px",
                    fontFamily: '"Plus Jakarta Sans", sans-serif',
                  }}
                >
                  Policy Number not issued
                </span>
              ),
            };
          })}
        />
        {selectedPolicyNumber
          ? renderDocuments(
              DocumentDetails[type]?.filter(
                (doc) => {
                  const hasValidPolicyNumber = doc.policy_number && 
                    (typeof doc.policy_number === 'string' ? doc.policy_number.trim() !== "" : true);
                  const docKey = hasValidPolicyNumber ? doc.policy_number : (doc.policy_id || `policy-${DocumentDetails[type].indexOf(doc)}`);
                  return docKey === selectedPolicyNumber;
                }
              ) || []
            )
          : renderDocuments([])}
      </>
    ),
  }));

  return (
    <Spin spinning={loading}>
      <div className="escalation-matrix-container">
        <div className="escalation-content">
          <Row className="escalation-row-header">
          <span style={{ fontWeight: "700", fontSize: "20px" }}>
            {user?.corporate_name || "Guest"}
            </span>{" "}
            {/* UPDATED: This now correctly displays the financial year from Redux */}
            <span style={{ marginLeft: "8px" }}>
              (Financial Year: {selectedYear})
            </span>
          </Row>
        </div>
        {policyTypes.length > 0 ? (
          <Tabs
            activeKey={activeTab}
            onChange={handleTabChange}
            className="esc-tab"
            items={tabItems}
          />
        ) : (
          <Card style={{ marginTop: "20px" }}>
            <div style={{ textAlign: "center", padding: "40px", color: "#666" }}>
              <p style={{ fontSize: "16px", fontWeight: "500" }}>No document data available for {selectedYear}</p>
            </div>
          </Card>
        )}
      </div>
    </Spin>
  );
};

export default Document;